
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.475 4.842h6.631M10.225 7.248l1.157.89a.2.2 0 00.322-.158V3.965c0-1.474 1.555-1.924 2.333-1.965H3.967C2.493 2 2.043 3.31 2.002 3.965V7.98a.2.2 0 00.322.158l1.157-.89a.2.2 0 01.238-.004l1.473 1.052a.2.2 0 00.244-.009L6.668 7.26a.2.2 0 01.25-.004l1.352 1.04a.2.2 0 00.239.004l1.478-1.056a.2.2 0 01.238.004z","stroke":"#7D1E36","stroke-width":"1.3"}}),_c('path',{attrs:{"d":"M16.615 4.21v1.351h-4.912V3.965c0-1.474 1.556-1.924 2.334-1.965 1.473 0 2.578 1.105 2.578 2.21zM15.14 13.158H8.51M8.39 10.752l-1.157-.89a.2.2 0 00-.321.158v4.015c0 1.474-1.556 1.924-2.334 1.965h10.07c1.474 0 1.924-1.31 1.965-1.965V10.02a.2.2 0 00-.322-.158l-1.157.89a.2.2 0 01-.238.004l-1.473-1.052a.2.2 0 00-.244.009l-1.232 1.027a.2.2 0 01-.25.005l-1.352-1.04a.2.2 0 00-.238-.005l-1.478 1.056a.2.2 0 01-.239-.004z","stroke":"#7D1E36","stroke-width":"1.3"}}),_c('path',{attrs:{"d":"M2 13.79v-1.351h4.912v1.596c0 1.474-1.555 1.924-2.333 1.965-1.474 0-2.58-1.105-2.58-2.21z","stroke":"#7D1E36","stroke-width":"1.3"}})])
          )
        }
      }
    